var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list',{key:_vm.$store.state.organisations.organisationMemberKey,attrs:{"editRole":_vm.editRole}}),(!_vm.edit)?_c('add'):_vm._e(),(_vm.edit)?_c('edit',{key:_vm.edit.username,attrs:{"edit":_vm.edit,"callback":_vm.setSuccess}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }